import TemplateView from "../../../TemplateView"
import ProjectTasksBlock from "./ProjectTasksBlock"
import { isOrderFullyExistsAtTheBeginningOf } from "../../../atUtils"
import messageResource from "../../../messageResource"
import { WorkflowStatusType } from "../../../workflowStatus/constants"
import $ from "jquery"
import ComponentTooltip from "../../../ComponentTooltip"

export default class KanbanContent extends TemplateView {
    constructor({
        onProjectHeaderClick = (projectId) => { },
        onTaskStatusAndPositionChanged = () => { },
        onSelectTaskHandler = () => { },
        onTaskClick = taskId => { },
        closeAnyTaskPanel = () => { },
        onCardActiveSelectionDisappear = () => { },
    }) {
        super()

        this.onProjectHeaderClick = onProjectHeaderClick;
        this.onTaskClick = onTaskClick;
        this.closeAnyTaskPanel = closeAnyTaskPanel
        this.onSelectTaskHandler = onSelectTaskHandler
        this.onTaskStatusAndPositionChanged = onTaskStatusAndPositionChanged;
        this.onCardActiveSelectionDisappear = onCardActiveSelectionDisappear

        this.projectBlocks = {};

        this.state = {
            statuses: [],
            projectsWithGroupedTasks: [],
            customers: {},
            showSingleProject: false,
            showSingleCustomer: false,
            canEditTaskStatus: true,
            taskIdWithDetailsOpen: null,
            selectedTaskIds: {},
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            draggingTaskId: null,
            draggingTaskProjectId: null,
            updatingTaskIds: {},
            minimizedCards: false,
            showSelection: false,
            showEstimate: false,
            collapsedProjectIds: {},
            ignoreProjectCollapse: false,
            manageableTaskIds: {},
        }

        this.onStateDeeplyChanged((state, prevState) => {
            this._updateProjects(state, prevState)
        })
    }

    templateHtml() {
        return "<div class='kanbanContent'>" +
            "</div>"
    }

    _updateProjects(state, prevState) {
        if (!isOrderFullyExistsAtTheBeginningOf(prevState.projectsWithGroupedTasks, state.projectsWithGroupedTasks)) {
            this.$el.empty()
            this.projectBlocks = {}
        }

        this._projectIndexById = state.projectsWithGroupedTasks.reduce((map, project, index) => {
            map[project.id] = index
            return map
        }, {})

        state.projectsWithGroupedTasks.forEach(project => {
            if (!this.projectBlocks[project.id]) {
                this.projectBlocks[project.id] = new ProjectTasksBlock({
                    projectId: project.id,
                    canReopenProject: project.canReopenProject,
                    canEditTaskStatus: this.state.canEditTaskStatus,
                    canManageAllProjectTasks: project.canManageAllProjectTasks,
                    onHeaderClick: () => this.onProjectHeaderClick(project.id),
                    onSelectTaskHandler: this.onSelectTaskHandler,
                    onTaskClick: taskId => this.onTaskClick(taskId),
                    onTaskStatusAndPositionChanged: (data) => {
                        const draggingTaskId = this.state.draggingTaskId
                        this.setStateInternal({
                            draggingTaskProjectId: null,
                            draggingTaskId: null,
                        })
                        this.onTaskStatusAndPositionChanged({
                            ...data,
                            taskId: data.taskId || draggingTaskId,
                        })
                    },
                    onTaskDragStart: (projectId, taskId) => {
                        this.setStateInternal({
                            draggingTaskProjectId: projectId,
                            draggingTaskId: taskId,
                        })
                        Object.values(this.projectBlocks).forEach(projectBlock => {
                            projectBlock.setState({
                                canDropDraggingTask: (!!this.state.manageableTaskIds[taskId] && projectBlock.canManageAllProjectTasks)
                                    || (projectId === projectBlock.projectId)
                            })
                        })

                        this.closeAnyTaskPanel()
                    },
                    onTaskDragStop: () => {
                        this.setStateInternal({
                            draggingTaskProjectId: null,
                        })
                    },
                    onTasksColumnDragOver: (canDrop, status) => {
                        const draggingTaskProject = this.state.projectsWithGroupedTasks[this._projectIndexById[this.state.draggingTaskProjectId]]

                        if (!canDrop || project.id !== draggingTaskProject.id)
                            this._showTooltip(project, status, draggingTaskProject, !!this.state.manageableTaskIds[this.state.draggingTaskId])
                    },
                    onTasksColumnDragOut: () => {
                        this.getTooltip().hide()
                    },
                    onCardActiveSelectionDisappear: this.onCardActiveSelectionDisappear,
                }).init(this.$el);
            }

            this.projectBlocks[project.id].setState({
                statuses: state.statuses,
                tasksByStatus: project.tasksByStatus,
                collapsed: state.ignoreProjectCollapse ? false : !!state.collapsedProjectIds[project.id],
                taskIdWithDetailsOpen: state.taskIdWithDetailsOpen,
                selectedTaskIds: state.selectedTaskIds,
                lastCreatedTaskIds: state.lastCreatedTaskIds,
                recentlyCreatedTaskIds: state.recentlyCreatedTaskIds,
                minimizedCards: state.minimizedCards,
                updatingTaskIds: state.updatingTaskIds,
                showSelection: state.showSelection,
                showSingleProject: state.showSingleProject,
                showSingleCustomer: state.showSingleCustomer,
                showEstimate: state.showEstimate,
                ignoreProjectCollapse: state.ignoreProjectCollapse,
                canEditTaskStatus: this.state.canEditTaskStatus,
                customerName: state.customers[project.customerId].name,
                projectName: project.name,
                projectArchived: project.archived,
                customerArchived: state.customers[project.customerId].archived,
            })

            if (state.draggingTaskProjectId) {
                const draggingTaskProject = this.state.projectsWithGroupedTasks[this._projectIndexById[state.draggingTaskProjectId]]
                this.projectBlocks[project.id].setState({
                    canDropDraggingTask: (!!this.state.manageableTaskIds[this.state.draggingTaskId] && project.canManageAllProjectTasks)
                        || draggingTaskProject.id === project.id
                })
            }
        })

        if (state.draggingTaskProjectId) {
            this.projectBlocks[state.draggingTaskProjectId].setState({ needRefreshSortable: true })
        }
    }

    _showTooltip(project, status, draggingTaskProject, canManageTask) {

        let text = ""
        if (draggingTaskProject.id !== project.id) {
            if (!canManageTask) {
                text = messageResource.getMessage("task.list.kanban.cannot_move_non_manageable_task")
            } else if (!project.canManageAllProjectTasks) {
                text = messageResource.getMessage("task.list.kanban.cannot_move_task_to_non_manageable_project")
            } else {
                text = messageResource.getMessage("task.list.kanban.access_to_task_after_move_to_another_project")
            }
        }
        if (project.archived && status.type === WorkflowStatusType.OPEN && !project.canReopenProject) {
            if (draggingTaskProject.id === project.id) {
                text = messageResource.getMessage("task.list.kanban.cannot_reopen_archived_current")
            } else {
                text = messageResource.getMessage("task.list.kanban.cannot_reopen_archived")
            }
        }

        this.getTooltip().setState({ text })
        this.getTooltip().show();
    }

    getTooltip() {
        if (!KanbanContent.tooltip) {
            KanbanContent.tooltip = new ComponentTooltip({ extraClass: "kanbanView_tooltips_projectCannotDropTooltip" }).init($("body"));
        }
        return KanbanContent.tooltip
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/KanbanContent.js